import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import {
  Card as CardAnt,
  Carousel,
  Image,
  Modal,
  Popover,
  Tooltip,
} from "antd";
import { addToCart, removeFromCart } from "../../library/database";
import { AppContext } from "../../context";

import ProductInfo from "../ProductInfo/ProductInfo";
import AddToCartDialog from "../AddToCart/AddToCartDialog";

import openkit from "openkit";
import LoginModal from "../../container/User/LoginModal";
import { API_URL } from "../../config/config";
import { CARD_WIDTH } from "../../config/layoutConfig";
import { ENTITIES } from "../../entities/entitiesConfig";
openkit.config.app_url = API_URL;

const Card = ({
  entity,
  storeProp,
  product,
  children,
  removeBtn = false,
  reserveBtn = false,
  messagesBtn = false,
  updateList,
  setUpdateList,
  context,
}) => {
  const [isAddedToCartVisible, setIsAddedToCartVisible] = useState(false);
  const [isInfoVisible, setIsInfoVisible] = useState(false);
  const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);

  const [store, setStore] = useState(null);

  let info = useContext(AppContext);
  const history = useHistory();

  // if there's no store, get it based on product information
  // useEffect(() => {
  //   if (storeProp) {
  //     setStore(storeProp);
  //   } else {
  //     // in case the product is a restaurant table it can't be found from c_products table
  //     // in this case, the store id is registered in the product_id as "mesa_STOREID"
  //     let store_id;
  //     if (product.product_id?.includes("mesa")) {
  //       store_id = product.product_id.split("_")[1];
  //     }
  //     async function getStore() {
  //       let store;
  //       if (store_id) {
  //         // this is the case the product is a restaurant table
  //         store = await openkit.data.findOne("c_stores", {
  //           id: store_id,
  //         });
  //       } else {
  //         const prod = await openkit.data.findOne("c_products", {
  //           id: product.product_id || product.id,
  //         });

  //         store = await openkit.data.findOne("c_stores", {
  //           id: prod?.gen_store_id,
  //         });
  //       }
  //       setStore(store);
  //     }
  //     getStore(store);
  //   }
  // }, []);

  const stateBar = (productState) => {
    let stateTxt;
    switch (productState) {
      case "available":
        stateTxt =
          info.t("available") +
          (product.available_quantity <= 10
            ? " (Qtd = " + product.available_quantity + ")"
            : "");

        break;
      case "not-available":
        stateTxt = "Indisponível";
        break;
      case "not-defined":
        stateTxt = "Indique datas";
        break;
      // status da reserva
      case "confirmed":
        stateTxt = "Confirmado";
        break;
      case "pending":
        stateTxt = "Aguarda confirmação";
        break;
      case "rejected":
        stateTxt = "Rejeitado";
        break;
      default:
        break;
    }
    return (
      productState && (
        <div className={"availability " + productState}>
          <p>{stateTxt}</p>
        </div>
      )
    );
  };

  useEffect(() => {
    // remover a expressão 'Preview' do componente Image, adicionando svg para um icon de um olho
    let x = document.getElementsByClassName("ant-image-mask-info");
    if (x.length > 0) {
      for (const comp of x) {
        comp.innerHTML =
          '<span role="img" aria-label="eye" class="anticon anticon-eye"><svg viewBox="64 64 896 896" focusable="false" data-icon="eye" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"></path></svg></span>';
      }
    }
  }, []);

  const validateUserLoggedIn = () => {
    if (info?.user?.id) {
      setIsAddedToCartVisible(true);
    } else {
      setIsLoginModalVisible(true);
    }
  };

  return (
    <>
      {entity && product && (
        <>
          <CardAnt
            hoverable
            onClick={() => console.log("CLICK")}
            style={{ width: CARD_WIDTH }}
            cover={
              <Carousel>
                {product.gen_files?.map((im, index) => (
                  <Image alt={im.alt} src={im.url} height={140} key={index} />
                ))}
              </Carousel>
            }
            key={product.id}
          >
            <div className="ahp-product-name">{product.gen_name}</div>
            <div className="ahp-store-name">{product.store_name}</div>
            {stateBar(product.status)}

            {/* Card content */}
            <div className="ahp-reservation-card-content">
              {React.createElement(ENTITIES[entity].CardContent, {
                entity,
                product,
                store,
                context,
              })}
              {children}
            </div>

            <div className="ahp-buttons">
              <button
                className="ahp-button"
                onClick={() => setIsInfoVisible(true)}
              >
                {info.t("information")}
              </button>
              {reserveBtn &&
                (product.external_link ? (
                  <a
                    className={"ahp-button"}
                    href={product.external_link}
                    target="_blank"
                    rel="noreferrer"
                    disabled={!(product.status === "available")}
                  >
                    {info.t("purchaseLink")}
                  </a>
                ) : (
                  <Popover
                    title={
                      product.status === "available"
                        ? info.t("pressToReserve")
                        : info.t("fillAllFields")
                    }
                  >
                    {/* the next outter div exists to prevent Tooltip from removing the button class*/}
                    <div>
                      <button
                        className={"ahp-button"}
                        onClick={validateUserLoggedIn}
                        disabled={!(product.status === "available")}
                        style={
                          product.status === "available"
                            ? {}
                            : { pointerEvents: "none" }
                        }
                      >
                        {product?.auto_reserve === "immediatly"
                          ? info.t("purchase")
                          : info.t("reserve")}
                      </button>
                    </div>
                  </Popover>
                ))}
              {removeBtn && (
                <button
                  className="ahp-button"
                  onClick={async () => {
                    await removeFromCart(product.id);
                    setUpdateList(!updateList);
                  }}
                >
                  {info.t("remove")}
                </button>
              )}
              {/* {messagesBtn && (
                <button
                  className="ahp-button"
                  onClick={() => {
                    history.push(`/reservas?tab=5&st=${store.slug}`);
                    info.setUpdateComponent(!info.updateComponent);
                  }}
                >
                  {info.t("messages")}
                </button>
              )} */}
            </div>
          </CardAnt>

          {isAddedToCartVisible && (
            <AddToCartDialog
              entity={entity}
              store={store}
              product={product}
              isAddedToCartVisible={isAddedToCartVisible}
              setIsAddedToCartVisible={setIsAddedToCartVisible}
              // key={new Date()}
            />
          )}
          {isInfoVisible && (
            <ProductInfo
              entity={entity}
              store={store}
              productProp={product}
              product={product}
              isInfoVisible={isInfoVisible}
              setIsInfoVisible={setIsInfoVisible}
              key={product.id}
            />
          )}
          <LoginModal
            isModalVisible={isLoginModalVisible}
            setIsModalVisible={setIsLoginModalVisible}
          />
        </>
      )}
    </>
  );
};

export default Card;
